import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ClosureDirective } from './closure.directive';
import { FullscreenDirective } from './fullscreen-toggle.directive';
import { HoverEffectSidebarDirective } from './hover-effect-sidebar.directive';
import { SidemenuToggleDirective } from './sidemenu-toggle.directive';
import { ToggleBtnDirective } from './toggle-btn.directive';
import { ToggleThemeDirective } from './toggle-theme.directive';
import { NgModule } from '@angular/core';

const DIRECTIVES = [
  ClosureDirective,
  FullscreenDirective,
  HoverEffectSidebarDirective,
  SidemenuToggleDirective,
  ToggleBtnDirective,
  ToggleThemeDirective
];

@NgModule({
  imports: [...DIRECTIVES],
  exports: [...DIRECTIVES]
})
export class DirectivesModule { }
